<template>
  <div class="clpicker">
    <div class="msg">
      {{ $t("datapesquisa") }}
      <a @click="$emit('closePicker')">
        <i data-icon-name="ChromeClose" aria-hidden="true" class="ms-Icon root-43"></i>
      </a>
    </div>
    <CalendarScroller 
      :startyear="2021"
      :endyear="2025"
      :cdate="currentweek"
      :selectionmode="true"
      :limitYears="true"
      :monthmode="monthmode"
      @set-data="setData" />
    <FilterNavigation
      v-if="hidenav != true"
      class="fixedtobottom"
      @setOption="setOption"
      :selectedOption="selectedOption"
      :options="options" />  
  </div>
</template>


<script>
import { computed } from "vue";
import CalendarScroller from '@/components/calendarScroller/calendarScroller.vue';
import FilterNavigation from "@/components/filterNavigation/filterNavigation.vue";
import { useMenuStore } from "@/stores/menu.ts";
import { useEventSearch } from "@/stores/eventSearch.ts";

export default {
  name: 'CalendarPicker',
  emits:[
    "closePicker",
    "setOption",
    "dateSelected"
  ],
  props:["hidenav","monthmode"],  
  inject:["toogleIsOnCalendar"],
  components:{
    CalendarScroller,
    FilterNavigation
  },
  setup(){

    const eventsearch = useEventSearch();
    const currentFilters = computed(()=>eventsearch.currentFilters);
    const currentweek = computed(()=> eventsearch.selectedWeek);

    function updateSelectedWeek(selectedWeek){
      eventsearch.setSelectedWeek(selectedWeek);
    }
    function updateCurrentFilters(updatedCurrentFilters){
      eventsearch.updateCurrentFilters(updatedCurrentFilters);
    }

    const menuStore = useMenuStore();
    const options = computed(() => menuStore.menuItems);
    const selectedOption = computed(() => menuStore.currentSelected);


    return {
      options,
      updateSelectedWeek,
      updateCurrentFilters,
      currentFilters,
      currentweek,
      selectedOption
    }
  },
  created(){
    this.toogleIsOnCalendar();
  },
  beforeUnmount(){
    this.toogleIsOnCalendar();
  },
  methods:{
    setData(data){
      this.updateSelectedWeek(data);
      /*
      é necessário emitir o dateSelected para fechar o picker
      quando estamos a escolher a data no formulário
      */
      this.$emit("dateSelected",data);
      this.updateCurrentFilters({
        ...this.currentFilters,
        date: data
      })
    },
    setOption(option){
      this.$emit('setOption', option)
    },
  }
}
</script>

<style scoped>
.clpicker{
  background-color: white;
  z-index: 6;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 74.19px;
  overscroll-behavior-y: contain;
  overflow-y: hidden;
}

.msg{
  font-family: "Montserrat";
  justify-content: space-between;
  display: flex;
  background-color: #292a2b;
  padding-top: 17px;
  padding-bottom: 12px;
  padding-left: 30px;
  padding-right: 30px;
  color: white;
}

a{
  color: white;
}

.fixedtobottom{
  position: fixed;
}

</style>